function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.876 6.568l-.835-2.576a1.558 1.558 0 00-.405-.72.908.908 0 00-.63-.272H6.909a.909.909 0 00-.63.272 1.559 1.559 0 00-.405.72l-.835 2.576M4.916 6.568H14c.26 0 .51.143.694.398.184.255.288.6.288.961v2.549a.83.83 0 01-.144.48c-.092.128-.217.2-.347.2H4.426c-.13 0-.256-.072-.348-.2a.83.83 0 01-.143-.48V7.927c0-.36.103-.706.287-.961s.434-.398.694-.398z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.543 11.155v.932a.874.874 0 01-.292.646 1.05 1.05 0 01-.707.267 1.05 1.05 0 01-.708-.267.874.874 0 01-.293-.646v-.912M7.357 11.155v.932a.874.874 0 01-.293.646 1.05 1.05 0 01-.707.267 1.05 1.05 0 01-.707-.267.874.874 0 01-.293-.646v-.912M2.073 6.568l.834-2.576c.08-.292.22-.543.406-.72A.909.909 0 013.943 3h2.853M4.023 11.155H1.459c-.13 0-.255-.071-.347-.199a.83.83 0 01-.144-.48V7.927c0-.36.104-.706.288-.961s.434-.398.694-.398h2.872M4.39 11.155v.932a.874.874 0 01-.292.646A1.05 1.05 0 013.39 13a1.05 1.05 0 01-.707-.267.874.874 0 01-.293-.646v-.912",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIconDealer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgIconDealer;